// extracted by mini-css-extract-plugin
export default {"container":"MainContent_container__nVBSQ"};